<template>
    <div style="text-align: center;width:100%;_height:300px;">
        <span style="text-align: center;color:red; ">禁止一个微信绑定多个用户<br>否则无法登录</span>
        <div >
          <wxlogin

            :appid="this.customGlobal.serverUrl.wxAppid"
            scope="snsapi_login"cit
            self_redirect="true"
            :redirect_uri="encodeURIComponent(this.customGlobal.serverUrl.orgBaseURI3)"
            :state="this.customGlobal.userInfoExt.cui_login_id"
            href="data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgew0KICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogIGJvcmRlcjogbm9uZTsNCiAgd2lkdGg6IDIwMHB4Ow0KICBoZWlnaHQ6IDIwMHB4Ow0KfQ0KLmltcG93ZXJCb3ggLnN0YXR1c3sNCiAgZGlzcGxheTogbm9uZQ0KfQ=="
          ></wxlogin>
        </div>


    </div>
</template>

<script>
import wxlogin from 'vue-wxlogin';
export default {
name: "WxGetCode",
  components: {
    wxlogin
  },
  created: function() {
    if (this.$route.query.code !== undefined) {
      this.wxCode = this.$route.query.code;
      this.wxScanCodeLogin()
    }else{
      console.info("未正常传递参数code");
    }
  },
  data(){
    return {

    }
  },
  methods:{

    wxScanCodeLogin(){
      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, .7)'
      });

      var p1 = this.customGlobal.getHttpClient(
        "/fr/getWxMiniMerCode2OpenToDB",
        // this.customGlobal.serverUrl.baseURI,
        "https://wx.jlshskj.cn",
        {"Content-Type": "application/json"},
        // {username:this.username,password:this.password});
        {code:this.wxCode,state:this.customGlobal.userInfoExt.cui_login_id});
      p1.then((res) => {
        loading.close();
        console.log("异步调用成功返回:"+JSON.stringify(res));

      },error=>{
        console.log("异步调用出错:"+JSON.stringify(error));
        loading.close();

        this.$alert(JSON.stringify(error.message), '认证出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:"+JSON.stringify(res));
        loading.close();


        this.$alert(JSON.stringify(res.message), '认证出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/right/WxGetCode.vue